import React, { useState, useEffect } from 'react';
import { getTaskHistory } from './service';
import View from './RetrieveTaskHistory.view';
import errorCb from 'Common/Utils/errorCb';
import { useDispatch } from 'react-redux';
import { infoToastAction } from 'utils';
import successimage from '../../../Green_tick.png';
import errorimage from '../../../Red_Cross.png';

const RetrieveTaskHistory = () => {
    document.title = `Contract Management - Retrieve Task History`;    
	const [data, setData] = useState([]);
	const [isLoaded, setisLoaded] = useState([0]);
	const dispatch = useDispatch();
	const globalDispatch = useDispatch();

	const loadData = async () => {
		var result = [];
		await getTaskHistory(errorCb([], 'Error fetching data.', dispatch)).then(res => {
			result = res;
		});

		result.forEach((item) => {
			if(item.status == 1)
			{
				item.statusImage = <img src={successimage} width={15} alt="Task success" />;
			}
			else
			{
				item.statusImage = <img src={errorimage} width={20} alt="Task error" />;
			}
		  });

		setData(result);

		if (result.length === 0) {
			globalDispatch(infoToastAction('No task history found'));
		}
	};

	useEffect(() => {
		if (isLoaded == 0) {
			setisLoaded(1);
			loadData();
		}
	});

	return <View data={data} />;
};

export default RetrieveTaskHistory;
